var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { TableTestIdFactory } from '../../interactions';
import styles from './TableRoot.module.css';
export const TableRoot = ({ 'aria-rowcount': ariaRowcount, children, className, 'data-testid': testId, elementRef, onBlur, onKeyDown, tableId, }) => {
    return (_jsx("table", { className: C(styles.Container, className), "data-testid": TableTestIdFactory.getTableRootTestId(testId), id: tableId, onBlur: onBlur, onKeyDown: onKeyDown, ref: elementRef, ...(ariaRowcount && { 'aria-rowcount': ariaRowcount }), children: children }));
};
_react_refresh_temp_1 = TableRoot;
$RefreshReg$(_react_refresh_temp_1, "TableRoot");
